import legalProvider from "@app/providers/legal/assets/lang"
import accountLogin from "@features/account-login/assets/lang"
import activityHistory from "@features/activity-history/assets/lang"
import balanceAdjustmentAlert from "@features/balance-adjustment-alert/assets/lang"
import balanceAdjustmentModal from "@features/balance-adjustment-modal/assets/lang"
import carbonAccountSettingsModal from "@features/carbon-account-settings-modal/assets/lang"
import carbonAccountSettings from "@features/carbon-account-settings/assets/lang"
import carbonBufferSettingsModal from "@features/carbon-buffer-settings-modal/assets/lang"
import carbonBufferSettings from "@features/carbon-buffer-settings/assets/lang"
import carbonCapturedAttributesList from "@features/carbon-captured-attributes-list/assets/lang"
import commentCard from "@features/comment-card/assets/lang"
import cycleDetailsActions from "@features/cycle-details-actions/assets/lang"
import cycleDetailsHeader from "@features/cycle-details-header/assets/lang"
import cycleFuelStats from "@features/cycle-fuel-stats/assets/lang"
import cycleListHeader from "@features/cycle-list-header/assets/lang"
import cycleList from "@features/cycle-list/assets/lang"
import cycleReviewForm from "@features/cycle-review-form/assets/lang"
import cycleStats from "@features/cycle-stats/assets/lang"
import declarationsDetailsForm from "@features/declaration-details-form/assets/lang"
import declarationList from "@features/declaration-list/assets/lang"
import failedOutboxMessages from "@features/failed-outbox-messages/assets/lang"
import invoicesList from "@features/invoices-list/assets/lang"
import languageManagement from "@features/language-management/assets/lang"
import materialDetailsHeader from "@features/material-details-header/assets/lang"
import materialsList from "@features/materials-list/assets/lang"
import plantBalanceAdjustmentModal from "@features/plant-balance-adjustment-modal/assets/lang"
import plantBalanceChart from "@features/plant-balance-chart/assets/lang"
import plantDetailsFilters from "@features/plant-details-filters/assets/lang"
import plantDetailsHeader from "@features/plant-details-header/assets/lang"
import plantEventList from "@features/plant-event-list/assets/lang"
import plantFilters from "@features/plant-filters/assets/lang"
import plantList from "@features/plant-list/assets/lang"
import productAllocationDetailsHeader from "@features/product-allocation-details-header/assets/lang"
import productAllocationFilters from "@features/product-allocation-filters/assets/lang"
import productAllocationInfo from "@features/product-allocation-info/assets/lang"
import productAllocationKpiStats from "@features/product-allocation-kpi-stats/assets/lang"
import productAllocationList from "@features/product-allocation-list/assets/lang"
import productAllocationModal from "@features/product-allocation-modal/assets/lang"
import productAllocationResolveAlert from "@features/product-allocation-resolve-alert/assets/lang"
import projectDetailHeader from "@features/project-detail-header/assets/lang"
import projectsList from "@features/projects-list/assets/lang"
import selectionOfDeclarationTypeForm from "@features/selection-of-declaration-type-form/assets/lang"
import selectionOfMaterialForm from "@features/selection-of-material-form/assets/lang"
import sensorDataList from "@features/sensor-data-list/assets/lang"
import transactionDetailsHeader from "@features/transaction-details-header/assets/lang"
import transactionOverviewHeader from "@features/transaction-overview-header/assets/lang"
import transactionValidation from "@features/transaction-validation/assets/lang"
import transactionsModal from "@features/transactions-modal/assets/lang"
import userMenu from "@features/user-menu/assets/lang"
import adminLayout from "@pages/admin/assets/lang"
import legal from "@pages/legal/assets/lang"
import imprint from "@pages/legal/imprint/assets/lang"
import openSourceAttributes from "@pages/legal/open-source-attribution/assets/lang"
import privacyPolicy from "@pages/legal/privacy-policy/assets/lang"
import termsAndConditions from "@pages/legal/terms-and-conditions/assets/lang"
import mrvLayout from "@pages/mrv/assets/lang"
import carbonReductionsDetails from "@pages/mrv/carbon-reductions-details/assets/lang"
import carbonReductions from "@pages/mrv/carbon-reductions/assets/lang"
import plantDetails from "@pages/mrv/plant-details/assets/lang"
import plantOverview from "@pages/mrv/plant-overview/assets/lang"
import productAllocationDetails from "@pages/mrv/product-allocation-details/assets/lang"
import productAllocation from "@pages/mrv/product-allocation/assets/lang"
import accessDenied from "@pages/technical/access-denied/assets/lang"
import noTransactionFound from "@pages/technical/no-transaction-found/assets/lang"
import notFound from "@pages/technical/not-found/assets/lang"
import serviceUnavailable from "@pages/technical/service-unavailable/assets/lang"
import unauthorized from "@pages/technical/unauthorized/assets/lang"
import declarationCreation from "@pages/transfer/declaration-creation/assets/lang"
import manageDeclarations from "@pages/transfer/manage-declarations/assets/lang"
import materialDetails from "@pages/transfer/material-details/assets/lang"
import projectDetail from "@pages/transfer/project-detail/assets/lang"
import shared from "@shared/assets/lang"
import {
	enabledLanguages,
	type SupportedLanguages,
} from "@shared/i18n/constants"
import accountabilityModal from "@shared/ui/accountability-modal/assets/lang"
import formWithSummary from "@shared/ui/form-with-summary/assets/lang"
import traceabilityModal from "@shared/ui/traceability-modal/assets/lang"
import carbonCaptureAndStorageCard from "@widgets/carbon-capture-and-storage-card/assets/lang"
import cycleDetailsCard from "@widgets/cycle-details-card/assets/lang"
import dnvCarbonReductionsCard from "@widgets/dnv-carbon-reductions-card/assets/lang"
import ensuringAccountabilityCard from "@widgets/ensuring-accountability-card/assets/lang"
import netZeroCementCard from "@widgets/net-zero-cement-card/assets/lang"
import { ResourceLanguage } from "i18next"

// import { outbox } from "../routes"

const allResources: Record<SupportedLanguages, ResourceLanguage> = {
	"en-US": {
		app: {
			legal: legalProvider.en,
		},
		features: {
			accountLogin: accountLogin.en,
			materialsList: materialsList.en,
			projectsList: projectsList.en,
			invoicesList: invoicesList.en,
			balanceAdjustmentAlert: balanceAdjustmentAlert.en,
			balanceAdjustmentModal: balanceAdjustmentModal.en,
			materialDetailsHeader: materialDetailsHeader.en,
			projectDetailHeader: projectDetailHeader.en,
			transactionDetailsHeader: transactionDetailsHeader.en,
			transactionOverviewHeader: transactionOverviewHeader.en,
			transactionValidation: transactionValidation.en,
			declarationList: declarationList.en,
			activityHistory: activityHistory.en,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.en,
			selectionOfMaterialForm: selectionOfMaterialForm.en,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.en,
			declarationsDetailsForm: declarationsDetailsForm.en,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.en,
			userMenu: userMenu.en,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.en,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.en,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
			productAllocationModal: productAllocationModal.en,
			productAllocationResolveAlert: productAllocationResolveAlert.en,
			plantFilters: plantFilters.en,
			plantList: plantList.en,
			plantDetailsHeader: plantDetailsHeader.en,
			plantDetailsFilters: plantDetailsFilters.en,
			carbonAccountSettings: carbonAccountSettings.en,
			carbonAccountSettingsModal: carbonAccountSettingsModal.en,
			carbonBufferSettings: carbonBufferSettings.en,
			carbonBufferSettingsModal: carbonBufferSettingsModal.en,
			plantEventList: plantEventList.en,
			plantBalanceAdjustmentModal: plantBalanceAdjustmentModal.en,
			plantBalanceChart: plantBalanceChart.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.en,
			materialDetails: materialDetails.en,
			projectDetail: projectDetail.en,
			declarationCreation: declarationCreation.en,
			unauthorized: unauthorized.en,
			accessDenied: accessDenied.en,
			serviceUnavailable: serviceUnavailable.en,
			noTransactionFound: noTransactionFound.en,
			notFound: notFound.en,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			plantOverview: plantOverview.en,
			plantDetails: plantDetails.en,
			imprint: imprint.en,
			termsAndConditions: termsAndConditions.en,
			privacyPolicy: privacyPolicy.en,
			openSourceAttributes: openSourceAttributes.en,
		},
		shared: {
			...shared.en,
			formWithSummary: formWithSummary.en,
			accountabilityModal: accountabilityModal.en,
			traceabilityModal: traceabilityModal.en,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.en,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.en,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.en,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.en,
		},
		layout: {
			legal: legal.en,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"de-DE": {
		app: {
			legal: legalProvider.de,
		},
		features: {
			accountLogin: accountLogin.de,
			materialsList: materialsList.de,
			projectsList: projectsList.de,
			invoicesList: invoicesList.de,
			materialDetailsHeader: materialDetailsHeader.de,
			projectDetailHeader: projectDetailHeader.de,
			transactionDetailsHeader: transactionDetailsHeader.de,
			transactionOverviewHeader: transactionOverviewHeader.de,
			transactionValidation: transactionValidation.de,
			declarationList: declarationList.de,
			activityHistory: activityHistory.de,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.de,
			selectionOfMaterialForm: selectionOfMaterialForm.de,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.de,
			declarationsDetailsForm: declarationsDetailsForm.de,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.de,
			userMenu: userMenu.de,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.de,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.de,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.de,
			materialDetails: materialDetails.de,
			projectDetail: projectDetail.de,
			declarationCreation: declarationCreation.de,
			unauthorized: unauthorized.de,
			accessDenied: accessDenied.de,
			serviceUnavailable: serviceUnavailable.de,
			noTransactionFound: noTransactionFound.de,
			notFound: notFound.de,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.de,
			termsAndConditions: termsAndConditions.de,
			privacyPolicy: privacyPolicy.de,
			openSourceAttributes: openSourceAttributes.de,
		},
		shared: {
			...shared.de,
			formWithSummary: formWithSummary.de,
			accountabilityModal: accountabilityModal.de,
			traceabilityModal: traceabilityModal.de,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.de,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.de,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.de,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.de,
		},
		layout: {
			legal: legal.de,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"es-ES": {
		app: {
			legal: legalProvider.es,
		},
		features: {
			accountLogin: accountLogin.es,
			materialsList: materialsList.es,
			projectsList: projectsList.es,
			invoicesList: invoicesList.es,
			materialDetailsHeader: materialDetailsHeader.es,
			projectDetailHeader: projectDetailHeader.es,
			transactionDetailsHeader: transactionDetailsHeader.es,
			transactionOverviewHeader: transactionOverviewHeader.es,
			transactionValidation: transactionValidation.es,
			declarationList: declarationList.es,
			activityHistory: activityHistory.es,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.es,
			selectionOfMaterialForm: selectionOfMaterialForm.es,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.es,
			declarationsDetailsForm: declarationsDetailsForm.es,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.es,
			userMenu: userMenu.es,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.es,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.es,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.es,
			materialDetails: materialDetails.es,
			projectDetail: projectDetail.es,
			declarationCreation: declarationCreation.es,
			unauthorized: unauthorized.es,
			accessDenied: accessDenied.es,
			serviceUnavailable: serviceUnavailable.es,
			noTransactionFound: noTransactionFound.es,
			notFound: notFound.es,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.es,
			termsAndConditions: termsAndConditions.es,
			privacyPolicy: privacyPolicy.es,
			openSourceAttributes: openSourceAttributes.es,
		},
		shared: {
			...shared.es,
			formWithSummary: formWithSummary.es,
			accountabilityModal: accountabilityModal.es,
			traceabilityModal: traceabilityModal.es,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.es,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.es,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.es,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.es,
		},
		layout: {
			legal: legal.es,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"el-GR": {
		app: {
			legal: legalProvider.el,
		},
		features: {
			accountLogin: accountLogin.el,
			materialsList: materialsList.el,
			projectsList: projectsList.el,
			invoicesList: invoicesList.el,
			materialDetailsHeader: materialDetailsHeader.el,
			projectDetailHeader: projectDetailHeader.el,
			transactionDetailsHeader: transactionDetailsHeader.el,
			transactionOverviewHeader: transactionOverviewHeader.el,
			transactionValidation: transactionValidation.el,
			declarationList: declarationList.el,
			activityHistory: activityHistory.el,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.el,
			selectionOfMaterialForm: selectionOfMaterialForm.el,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.el,
			declarationsDetailsForm: declarationsDetailsForm.el,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.el,
			userMenu: userMenu.el,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.el,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.el,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.el,
			materialDetails: materialDetails.el,
			projectDetail: projectDetail.el,
			declarationCreation: declarationCreation.el,
			unauthorized: unauthorized.el,
			accessDenied: accessDenied.el,
			serviceUnavailable: serviceUnavailable.el,
			noTransactionFound: noTransactionFound.el,
			notFound: notFound.el,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.el,
			termsAndConditions: termsAndConditions.el,
			privacyPolicy: privacyPolicy.el,
			openSourceAttributes: openSourceAttributes.el,
		},
		shared: {
			...shared.el,
			formWithSummary: formWithSummary.el,
			accountabilityModal: accountabilityModal.el,
			traceabilityModal: traceabilityModal.el,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.el,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.el,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.el,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.el,
		},
		layout: {
			legal: legal.el,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"cs-CZ": {
		app: {
			legal: legalProvider.cs,
		},
		features: {
			accountLogin: accountLogin.cs,
			materialsList: materialsList.cs,
			projectsList: projectsList.cs,
			invoicesList: invoicesList.cs,
			materialDetailsHeader: materialDetailsHeader.cs,
			projectDetailHeader: projectDetailHeader.cs,
			transactionDetailsHeader: transactionDetailsHeader.cs,
			transactionOverviewHeader: transactionOverviewHeader.cs,
			transactionValidation: transactionValidation.cs,
			declarationList: declarationList.cs,
			activityHistory: activityHistory.cs,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.cs,
			selectionOfMaterialForm: selectionOfMaterialForm.cs,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.cs,
			declarationsDetailsForm: declarationsDetailsForm.cs,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.cs,
			userMenu: userMenu.cs,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.cs,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.cs,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.cs,
			materialDetails: materialDetails.cs,
			projectDetail: projectDetail.cs,
			declarationCreation: declarationCreation.cs,
			unauthorized: unauthorized.cs,
			accessDenied: accessDenied.cs,
			serviceUnavailable: serviceUnavailable.cs,
			noTransactionFound: noTransactionFound.cs,
			notFound: notFound.cs,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.cs,
			termsAndConditions: termsAndConditions.cs,
			privacyPolicy: privacyPolicy.cs,
			openSourceAttributes: openSourceAttributes.cs,
		},
		shared: {
			...shared.cs,
			formWithSummary: formWithSummary.cs,
			accountabilityModal: accountabilityModal.cs,
			traceabilityModal: traceabilityModal.cs,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.cs,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.cs,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.cs,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.cs,
		},
		layout: {
			legal: legal.cs,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"bg-BG": {
		app: {
			legal: legalProvider.bg,
		},
		features: {
			accountLogin: accountLogin.bg,
			materialsList: materialsList.bg,
			projectsList: projectsList.bg,
			invoicesList: invoicesList.bg,
			materialDetailsHeader: materialDetailsHeader.bg,
			projectDetailHeader: projectDetailHeader.bg,
			transactionDetailsHeader: transactionDetailsHeader.bg,
			transactionOverviewHeader: transactionOverviewHeader.bg,
			transactionValidation: transactionValidation.bg,
			declarationList: declarationList.bg,
			activityHistory: activityHistory.bg,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.bg,
			selectionOfMaterialForm: selectionOfMaterialForm.bg,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.bg,
			declarationsDetailsForm: declarationsDetailsForm.bg,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.bg,
			userMenu: userMenu.bg,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.bg,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.bg,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.en,
			materialDetails: materialDetails.en,
			projectDetail: projectDetail.en,
			declarationCreation: declarationCreation.en,
			unauthorized: unauthorized.bg,
			accessDenied: accessDenied.bg,
			serviceUnavailable: serviceUnavailable.bg,
			noTransactionFound: noTransactionFound.bg,
			notFound: notFound.bg,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.bg,
			termsAndConditions: termsAndConditions.bg,
			privacyPolicy: privacyPolicy.bg,
			openSourceAttributes: openSourceAttributes.bg,
		},
		shared: {
			...shared.bg,
			formWithSummary: formWithSummary.bg,
			accountabilityModal: accountabilityModal.bg,
			traceabilityModal: traceabilityModal.bg,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.bg,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.bg,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.bg,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.bg,
		},
		layout: {
			legal: legal.bg,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"nl-NL": {
		app: {
			legal: legalProvider.nl,
		},
		features: {
			accountLogin: accountLogin.nl,
			materialsList: materialsList.nl,
			projectsList: projectsList.nl,
			invoicesList: invoicesList.nl,
			materialDetailsHeader: materialDetailsHeader.nl,
			projectDetailHeader: projectDetailHeader.nl,
			transactionDetailsHeader: transactionDetailsHeader.nl,
			transactionOverviewHeader: transactionOverviewHeader.nl,
			transactionValidation: transactionValidation.nl,
			declarationList: declarationList.nl,
			activityHistory: activityHistory.nl,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.nl,
			selectionOfMaterialForm: selectionOfMaterialForm.nl,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.nl,
			declarationsDetailsForm: declarationsDetailsForm.nl,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.nl,
			userMenu: userMenu.nl,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.nl,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.nl,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.en,
			materialDetails: materialDetails.en,
			projectDetail: projectDetail.en,
			declarationCreation: declarationCreation.en,
			unauthorized: unauthorized.nl,
			accessDenied: accessDenied.nl,
			serviceUnavailable: serviceUnavailable.nl,
			noTransactionFound: noTransactionFound.nl,
			notFound: notFound.nl,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.nl,
			termsAndConditions: termsAndConditions.nl,
			privacyPolicy: privacyPolicy.nl,
			openSourceAttributes: openSourceAttributes.nl,
		},
		shared: {
			...shared.nl,
			formWithSummary: formWithSummary.en,
			accountabilityModal: accountabilityModal.en,
			traceabilityModal: traceabilityModal.en,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.nl,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.nl,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.nl,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.nl,
		},
		layout: {
			legal: legal.nl,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"no-NO": {
		app: {
			legal: legalProvider.nb,
		},
		features: {
			accountLogin: accountLogin.nb,
			materialsList: materialsList.nb,
			projectsList: projectsList.nb,
			invoicesList: invoicesList.nb,
			materialDetailsHeader: materialDetailsHeader.nb,
			projectDetailHeader: projectDetailHeader.nb,
			transactionDetailsHeader: transactionDetailsHeader.nb,
			transactionOverviewHeader: transactionOverviewHeader.nb,
			transactionValidation: transactionValidation.nb,
			declarationList: declarationList.nb,
			activityHistory: activityHistory.nb,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.nb,
			selectionOfMaterialForm: selectionOfMaterialForm.nb,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.nb,
			declarationsDetailsForm: declarationsDetailsForm.nb,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.nb,
			userMenu: userMenu.nb,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.nb,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.nb,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.nb,
			materialDetails: materialDetails.nb,
			projectDetail: projectDetail.nb,
			declarationCreation: declarationCreation.nb,
			unauthorized: unauthorized.nb,
			accessDenied: accessDenied.nb,
			serviceUnavailable: serviceUnavailable.nb,
			noTransactionFound: noTransactionFound.no,
			notFound: notFound.nb,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.nb,
			termsAndConditions: termsAndConditions.nb,
			privacyPolicy: privacyPolicy.nb,
			openSourceAttributes: openSourceAttributes.nb,
		},
		shared: {
			...shared.nb,
			formWithSummary: formWithSummary.nb,
			accountabilityModal: accountabilityModal.nb,
			traceabilityModal: traceabilityModal.nb,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.nb,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.nb,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.nb,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.nb,
		},
		layout: {
			legal: legal.nb,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"fr-FR": {
		app: {
			legal: legalProvider.fr,
		},
		features: {
			accountLogin: accountLogin.fr,
			materialsList: materialsList.fr,
			projectsList: projectsList.fr,
			invoicesList: invoicesList.fr,
			materialDetailsHeader: materialDetailsHeader.fr,
			projectDetailHeader: projectDetailHeader.fr,
			transactionDetailsHeader: transactionDetailsHeader.fr,
			transactionOverviewHeader: transactionOverviewHeader.fr,
			transactionValidation: transactionValidation.fr,
			declarationList: declarationList.fr,
			activityHistory: activityHistory.fr,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.fr,
			selectionOfMaterialForm: selectionOfMaterialForm.fr,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.fr,
			declarationsDetailsForm: declarationsDetailsForm.fr,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.fr,
			userMenu: userMenu.fr,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.fr,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.fr,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.en,
			materialDetails: materialDetails.en,
			projectDetail: projectDetail.en,
			declarationCreation: declarationCreation.en,
			unauthorized: unauthorized.fr,
			accessDenied: accessDenied.fr,
			serviceUnavailable: serviceUnavailable.fr,
			noTransactionFound: noTransactionFound.fr,
			notFound: notFound.fr,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.fr,
			termsAndConditions: termsAndConditions.fr,
			privacyPolicy: privacyPolicy.fr,
			openSourceAttributes: openSourceAttributes.fr,
		},
		shared: {
			...shared.fr,
			formWithSummary: formWithSummary.en,
			accountabilityModal: accountabilityModal.en,
			traceabilityModal: traceabilityModal.en,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.fr,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.fr,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.fr,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.fr,
		},
		layout: {
			legal: legal.fr,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"it-IT": {
		app: {
			legal: legalProvider.it,
		},
		features: {
			accountLogin: accountLogin.it,
			materialsList: materialsList.it,
			projectsList: projectsList.it,
			invoicesList: invoicesList.it,
			materialDetailsHeader: materialDetailsHeader.it,
			projectDetailHeader: projectDetailHeader.it,
			transactionDetailsHeader: transactionDetailsHeader.it,
			transactionOverviewHeader: transactionOverviewHeader.it,
			transactionValidation: transactionValidation.it,
			declarationList: declarationList.it,
			activityHistory: activityHistory.it,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.it,
			selectionOfMaterialForm: selectionOfMaterialForm.it,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.it,
			declarationsDetailsForm: declarationsDetailsForm.it,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.it,
			userMenu: userMenu.it,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.it,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.it,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.it,
			materialDetails: materialDetails.it,
			projectDetail: projectDetail.it,
			declarationCreation: declarationCreation.it,
			unauthorized: unauthorized.it,
			accessDenied: accessDenied.it,
			serviceUnavailable: serviceUnavailable.it,
			noTransactionFound: noTransactionFound.it,
			notFound: notFound.it,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.it,
			termsAndConditions: termsAndConditions.it,
			privacyPolicy: privacyPolicy.it,
			openSourceAttributes: openSourceAttributes.it,
		},
		shared: {
			...shared.it,
			formWithSummary: formWithSummary.it,
			accountabilityModal: accountabilityModal.it,
			traceabilityModal: traceabilityModal.it,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.it,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.it,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.it,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.it,
		},
		layout: {
			legal: legal.it,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"pl-PL": {
		app: {
			legal: legalProvider.pl,
		},
		features: {
			accountLogin: accountLogin.pl,
			materialsList: materialsList.pl,
			projectsList: projectsList.pl,
			invoicesList: invoicesList.pl,
			materialDetailsHeader: materialDetailsHeader.pl,
			projectDetailHeader: projectDetailHeader.pl,
			transactionDetailsHeader: transactionDetailsHeader.pl,
			transactionOverviewHeader: transactionOverviewHeader.pl,
			transactionValidation: transactionValidation.pl,
			declarationList: declarationList.pl,
			activityHistory: activityHistory.pl,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.pl,
			selectionOfMaterialForm: selectionOfMaterialForm.pl,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.pl,
			declarationsDetailsForm: declarationsDetailsForm.pl,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.pl,
			userMenu: userMenu.pl,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.pl,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.pl,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.pl,
			materialDetails: materialDetails.pl,
			projectDetail: projectDetail.pl,
			declarationCreation: declarationCreation.pl,
			unauthorized: unauthorized.pl,
			accessDenied: accessDenied.pl,
			serviceUnavailable: serviceUnavailable.pl,
			noTransactionFound: noTransactionFound.pl,
			notFound: notFound.pl,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.pl,
			termsAndConditions: termsAndConditions.pl,
			privacyPolicy: privacyPolicy.pl,
			openSourceAttributes: openSourceAttributes.pl,
		},
		shared: {
			...shared.pl,
			formWithSummary: formWithSummary.pl,
			accountabilityModal: accountabilityModal.pl,
			traceabilityModal: traceabilityModal.pl,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.pl,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.pl,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.pl,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.pl,
		},
		layout: {
			legal: legal.pl,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"ro-RO": {
		app: {
			legal: legalProvider.ro,
		},
		features: {
			accountLogin: accountLogin.ro,
			materialsList: materialsList.ro,
			projectsList: projectsList.ro,
			invoicesList: invoicesList.ro,
			materialDetailsHeader: materialDetailsHeader.ro,
			projectDetailHeader: projectDetailHeader.ro,
			transactionDetailsHeader: transactionDetailsHeader.ro,
			transactionOverviewHeader: transactionOverviewHeader.ro,
			transactionValidation: transactionValidation.ro,
			declarationList: declarationList.ro,
			activityHistory: activityHistory.ro,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.ro,
			selectionOfMaterialForm: selectionOfMaterialForm.ro,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.ro,
			declarationsDetailsForm: declarationsDetailsForm.ro,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.ro,
			userMenu: userMenu.ro,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.ro,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.ro,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.ro,
			materialDetails: materialDetails.ro,
			projectDetail: projectDetail.ro,
			declarationCreation: declarationCreation.ro,
			unauthorized: unauthorized.ro,
			accessDenied: accessDenied.ro,
			serviceUnavailable: serviceUnavailable.ro,
			noTransactionFound: noTransactionFound.ro,
			notFound: notFound.ro,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.ro,
			termsAndConditions: termsAndConditions.ro,
			privacyPolicy: privacyPolicy.ro,
			openSourceAttributes: openSourceAttributes.ro,
		},
		shared: {
			...shared.ro,
			formWithSummary: formWithSummary.ro,
			accountabilityModal: accountabilityModal.ro,
			traceabilityModal: traceabilityModal.ro,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.ro,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.ro,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.ro,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.ro,
		},
		layout: {
			legal: legal.ro,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
	"sv-SE": {
		app: {
			legal: legalProvider.sv,
		},
		features: {
			accountLogin: accountLogin.sv,
			materialsList: materialsList.sv,
			projectsList: projectsList.sv,
			invoicesList: invoicesList.sv,
			materialDetailsHeader: materialDetailsHeader.sv,
			projectDetailHeader: projectDetailHeader.sv,
			transactionDetailsHeader: transactionDetailsHeader.sv,
			transactionOverviewHeader: transactionOverviewHeader.sv,
			transactionValidation: transactionValidation.sv,
			declarationList: declarationList.sv,
			activityHistory: activityHistory.sv,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.sv,
			selectionOfMaterialForm: selectionOfMaterialForm.sv,
			selectionOfDeclarationTypeForm: selectionOfDeclarationTypeForm.sv,
			declarationsDetailsForm: declarationsDetailsForm.sv,
			failedOutboxMessages: failedOutboxMessages.en,
			languageManagement: languageManagement.en,
			productAllocationList: productAllocationList.en,
			productAllocationKpiStats: productAllocationKpiStats.en,
			carbonCapturedAttributesList: carbonCapturedAttributesList.sv,
			userMenu: userMenu.sv,
			cycleReviewForm: cycleReviewForm.en,
			commentCard: commentCard.sv,
			cycleStats: cycleStats.en,
			cycleList: cycleList.en,
			cycleListHeader: cycleListHeader.en,
			cycleDetailsHeader: cycleDetailsHeader.en,
			cycleFuelStats: cycleFuelStats.en,
			sensorDataList: sensorDataList.en,
			cycleDetailsActions: cycleDetailsActions.en,
			transactionsModal: transactionsModal.sv,
			productAllocationFilters: productAllocationFilters.en,
			productAllocationDetailsHeader: productAllocationDetailsHeader.en,
			productAllocationInfo: productAllocationInfo.en,
		},
		pages: {
			manageDeclarations: manageDeclarations.sv,
			materialDetails: materialDetails.sv,
			projectDetail: projectDetail.sv,
			declarationCreation: declarationCreation.sv,
			unauthorized: unauthorized.sv,
			accessDenied: accessDenied.sv,
			serviceUnavailable: serviceUnavailable.sv,
			noTransactionFound: noTransactionFound.sv,
			notFound: notFound.sv,
			productAllocation: productAllocation.en,
			productAllocationDetails: productAllocationDetails.en,
			carbonReductions: carbonReductions.en,
			carbonReductionsDetails: carbonReductionsDetails.en,
			imprint: imprint.sv,
			termsAndConditions: termsAndConditions.sv,
			privacyPolicy: privacyPolicy.sv,
			openSourceAttributes: openSourceAttributes.sv,
		},
		shared: {
			...shared.sv,
			formWithSummary: formWithSummary.sv,
			accountabilityModal: accountabilityModal.sv,
			traceabilityModal: traceabilityModal.sv,
		},
		widgets: {
			netZeroCementCard: netZeroCementCard.sv,
			carbonCaptureAndStorageCard: carbonCaptureAndStorageCard.sv,
			cycleDetailsCard: cycleDetailsCard.en,
			ensuringAccountabilityCard: ensuringAccountabilityCard.sv,
			dnvCarbonReductionsCard: dnvCarbonReductionsCard.sv,
		},
		layout: {
			legal: legal.sv,
			mrv: mrvLayout.en,
			admin: adminLayout.en,
		},
	},
}

export const resources = Object.fromEntries(
	Object.entries(allResources).filter(([key]) =>
		(enabledLanguages as readonly string[]).includes(key),
	),
) as Record<SupportedLanguages, ResourceLanguage>
